import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarDays, ChevronRight, Users } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// Card scurtătură spre Calendarul Ore simplu (doar useri cu simple_hours_calendar).
export default function SimpleHoursCard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [total, setTotal] = useState(null);

  const enabled = !!user?.simple_hours_calendar;
  const pid = user?.person_id;

  useEffect(() => {
    if (!enabled || !pid) return;
    const now = new Date();
    api.get("/simple-hours/month", { params: { person_id: pid, year: now.getFullYear(), month: now.getMonth() + 1 } })
      .then((r) => {
        let h = 0;
        Object.values(r.data.days || {}).forEach((e) => { h += (e.hours || 0) + (e.hours_driven || 0); });
        setTotal(h);
      })
      .catch(() => setTotal(null));
  }, [enabled, pid]);

  if (!enabled) return null;

  const monthName = new Date().toLocaleDateString("ro-RO", { month: "long" });

  return (
    <button
      onClick={() => navigate("/ore-simple")}
      className="w-full text-left rounded-2xl bg-emerald-600 active:bg-emerald-700 hover:bg-emerald-700 transition-colors shadow-lg p-4 flex items-center gap-4"
      data-testid="simple-hours-shortcut-card"
    >
      <div className="w-12 h-12 rounded-xl bg-white/15 flex items-center justify-center flex-shrink-0">
        <CalendarDays className="w-6 h-6 text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-white font-black text-base leading-tight">Calendar Ore</div>
        <div className="text-emerald-100 text-sm font-medium">
          {total !== null && (
            <span className="font-bold text-white">{total % 1 === 0 ? total : total.toFixed(1)}h în {monthName}</span>
          )}
          {total !== null && " · "}
          <span className="inline-flex items-center gap-1"><Users className="w-3.5 h-3.5 inline" /> orele tale și ale angajaților</span>
        </div>
      </div>
      <ChevronRight className="w-6 h-6 text-white/70 flex-shrink-0" />
    </button>
  );
}
